import React from 'react';
import styles from './DatePickerInput.styles.scss';
import cn from 'classnames';
import { DatePicker } from '../DatePicker';

const DatePickerInput = ({ hasError, className, ...props }) => {
  return (
    <DatePicker
      className={cn(styles.calendar, className, hasError ? 'hasError' : '')}
      showIcon={true}
      readOnlyInput={true}
      {...props}
    />
  );
};

export default React.memo(DatePickerInput);
